import { render } from "./AdminReservations.vue?vue&type=template&id=34be8b14&scoped=true"
import script from "./AdminReservations.vue?vue&type=script&lang=js"
export * from "./AdminReservations.vue?vue&type=script&lang=js"

import "./AdminReservations.vue?vue&type=style&index=0&id=34be8b14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34be8b14"]])

export default __exports__